import { render, staticRenderFns } from "./dispatch-modal.vue?vue&type=template&id=4047f0da&scoped=true"
import script from "./dispatch-modal.vue?vue&type=script&lang=js"
export * from "./dispatch-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047f0da",
  null
  
)

export default component.exports